export function LoadingSpinner() {
  return (
    <div className="flex-shrink-0 h-[20px] w-[20px] border-2 borderinnoveraZinc-300 border-t-innoveraZinc-900 border-solid rounded-full animate-spin" />
  );
}
